module.exports = "/images/quote-mark.png?385228f87d63a02a36551063c434d195";